import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import '../components/cp-memory-timeline.js';
import '../components/cp-memory-gaps.js';
import '../components/cp-memory-conversation.js';
import '../components/cp-skill-promotion-pipeline.js';

type DashboardSection = 'timeline' | 'gaps' | 'conversation' | 'pipeline';

@customElement('cp-page-memory-dashboard')
export class CpPageMemoryDashboard extends LitElement {
  createRenderRoot() { return this; }

  @state() private _section: DashboardSection = 'timeline';

  private _switchSection(s: DashboardSection): void {
    this._section = s;
  }

  render() {
    return html`
      <div class="cp-page memory-dashboard-page">
        <div class="memory-dashboard__header">
          <h2 class="memory-dashboard__title">Memory Dashboard</h2>
          <nav class="memory-dashboard__nav">
            ${this._navBtn('timeline', 'Audit-Timeline')}
            ${this._navBtn('gaps', 'Wissens-Lücken')}
            ${this._navBtn('conversation', 'Konversationen')}
            ${this._navBtn('pipeline', 'Skill-Pipeline')}
          </nav>
        </div>

        <div class="memory-dashboard__content">
          ${this._renderSection()}
        </div>
      </div>
    `;
  }

  private _navBtn(section: DashboardSection, label: string) {
    const active = this._section === section;
    return html`
      <button
        class="memory-dashboard__nav-btn ${active ? 'memory-dashboard__nav-btn--active' : ''}"
        @click=${() => this._switchSection(section)}
      >${label}</button>
    `;
  }

  private _renderSection() {
    switch (this._section) {
      case 'timeline':
        return html`<cp-memory-timeline></cp-memory-timeline>`;
      case 'gaps':
        return html`<cp-memory-gaps></cp-memory-gaps>`;
      case 'conversation':
        return html`<cp-memory-conversation></cp-memory-conversation>`;
      case 'pipeline':
        return html`<cp-skill-promotion-pipeline></cp-skill-promotion-pipeline>`;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-page-memory-dashboard': CpPageMemoryDashboard;
  }
}
